// ═══ 대행사 거래처 화면 `/main/m/clients` (W1b · 시안 BrokerClients) — 더보기 '거래처' 행에서 들어온다 ═══
// 행 = GET /my/malso-clients (본인 몫 맨 앞, 나머지 이름순, 사용 중 거래처만). 배지: 본인 / 가입.
// 주소: 본인 = 업체 수거 주소(더보기 '수거 주소' 에서 고침 · 없으면 업체 주소, D5 — 본인 행엔 ⋯ 없음) · 하위 = 저장한 수거 주소.
// 대표(currentRole 'owner')만 [거래처 추가](W1a NewClientSheet 재사용)·[초대](미가입 하위만 — MalsoInviteSheet) — 역할 없음·member 숨김.
// 하위 행 ⋯ = 수거 주소 수정(owner·member — 서버 PUT 도 둘 다 허용). 거래처 이름은 YK 만 고친다(Jin 결정 10).
// 비대행사(isBroker false)로 들어오면 더보기로 되돌린다.
// props: { user, showToast }
import React, { useState, useEffect, useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { T, R, S, FONT } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { listMalsoClients, putMalsoClientPickup, listAgencies, getCompany } from '../api';
import { describeSimpleError } from '../../simple/errors';
import ErrorText from '../../simple/parts/ErrorText';
import SimpleCard from '../../simple/parts/SimpleCard';
import ConfirmSheet from '../../simple/parts/ConfirmSheet';
import NewClientSheet from '../parts/NewClientSheet';
import MalsoInviteSheet from '../parts/MalsoInviteSheet';

var page = { display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 720, width: '100%', margin: '0 auto' };
var titleRow = { display: 'flex', alignItems: 'center', gap: 10 };
var backBtn = { width: 30, height: 30, borderRadius: R.sm, border: '1px solid ' + T.bd, background: T.card,
  color: T.body, cursor: 'pointer', fontFamily: 'inherit', display: 'grid', placeItems: 'center', flex: 'none', padding: 0 };
var h2 = { flex: 1, minWidth: 0, fontSize: FONT.title, fontWeight: 800, color: T.ink, letterSpacing: '-.3px', margin: 0 };
var addBtn = { height: 34, padding: '0 12px', borderRadius: R.md, border: '1px solid ' + T.navy, background: T.navy, color: T.card,
  fontSize: 13, fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer', flex: 'none' };
var lead = { fontSize: 13, color: T.dim, lineHeight: 1.55 };
var foot = { fontSize: 12, color: T.muted, lineHeight: 1.55 };
var row = { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', borderBottom: '1px solid ' + T.bdSoft, minWidth: 0 };
var rowLast = Object.assign({}, row, { borderBottom: 0 });
var tx = { flex: 1, minWidth: 0 };
var nameSt = { display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 700, color: T.ink, minWidth: 0 };
var addrSt = { display: 'block', fontSize: 12, color: T.muted, marginTop: 2, overflowWrap: 'anywhere' };
var badge = { fontSize: FONT.badge, fontWeight: 700, borderRadius: R.sm, padding: '1px 6px', flex: 'none' };
var badgeSelf = Object.assign({}, badge, { background: T.track, color: T.dim });
var badgeJoined = Object.assign({}, badge, { background: T.okTint, color: T.ok });
var inviteBtn = { height: 32, padding: '0 12px', borderRadius: R.md, border: '1px solid ' + T.accentBd, background: T.card,
  color: T.accentPress, fontSize: 12.5, fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer', flex: 'none' };
var moreBtn = { width: 30, height: 30, border: 0, background: 'none', color: T.faint, cursor: 'pointer', flex: 'none',
  display: 'grid', placeItems: 'center', padding: 0, fontFamily: 'inherit' };
var moreSlot = { width: 30, flex: 'none' };

/// 하위 거래처 수거 주소 수정 시트 — 열려 있을 때만 mount. 입력 상한은 onChange 에서 자른다(서버 500).
function PickupEditSheet(props) {
  var t = useT();
  var st = useState(props.client.pickupAddress || ''); var value = st[0], setValue = st[1];
  var stB = useState(false); var busy = stB[0], setBusy = stB[1];
  var save = function () {
    if (busy) return;
    setBusy(true);
    putMalsoClientPickup(props.client.id, value.trim()).then(function () { props.onSaved(); }, function (e) {
      setBusy(false);
      props.showToast(describeSimpleError(t, e), 'err');
    });
  };
  return (<ConfirmSheet open title={t('malsoModeBrokerEditPickup')} sub={props.client.name} confirmLabel={t('actionSave')}
    onConfirm={save} onClose={props.onClose}>
    <input type="text" style={S.input} data-testid="client-pickup-input" value={value} aria-label={t('carCancelPickupSection')}
      onChange={function (e) { setValue(e.target.value.slice(0, 500)); }} />
  </ConfirmSheet>);
}

function MalsoClients(props) {
  var t = useT();
  var navigate = useNavigate();
  var user = props.user || {};
  var showToast = props.showToast || function () {};
  var canManage = user.currentRole === 'owner';   // 서버 POST·invite owner 가드와 같은 기준(W1a 58561ab6)
  var stC = useState(null); var data = stC[0], setData = stC[1];   // listMalsoClients 응답
  var stE = useState(null); var err = stE[0], setErr = stE[1];
  var stS = useState(null); var sheet = stS[0], setSheet = stS[1];   // { kind:'add'|'invite'|'pickup', client }
  var stA = useState(''); var agencyName = stA[0], setAgencyName = stA[1];
  var stP = useState(''); var selfAddr = stP[0], setSelfAddr = stP[1];
  var cid = user.activeCompanyId || user.companyId;

  var load = useCallback(function () {
    return listMalsoClients().then(function (d) { setData(d || { isBroker: false }); setErr(null); }, function (e) { setErr(e); });
  // setter 는 useState 가 보장하는 안정 참조 — 배열 구조분해라 린터가 못 알아본다.
  }, [setData, setErr]);

  useEffect(function () {
    var alive = true;
    load();
    // 새 거래처 시트 안내 상자의 말소대행사 이름 — 사용 중 1곳일 때만(신청 화면과 같은 규칙).
    listAgencies().then(function (list) {
      if (alive && Array.isArray(list) && list.length === 1) setAgencyName(String(list[0].name || ''));
    }).catch(function () { /* 안내 상자만 없음 */ });
    getCompany(cid).then(function (c) {
      if (alive) setSelfAddr(String((c && (c.pickupAddress || c.addrKr)) || ''));
    }).catch(function () { /* 본인 주소 줄만 비움 */ });
    return function () { alive = false; };
  }, [load, cid, setAgencyName, setSelfAddr]);

  if (data && !data.isBroker) return <Navigate to="/main/m/more" replace />;

  var close = function () { setSheet(null); };
  var list = (data && data.clients) || [];

  return (<div style={page}>
    <div style={titleRow}>
      <button type="button" style={backBtn} aria-label={t('actionBack')} onClick={function () { navigate('/main/m/more'); }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" /></svg>
      </button>
      <h2 style={h2}>{t('malsoModeBrokerClients')}</h2>
      {data && canManage ? (<button type="button" style={addBtn} data-testid="clients-add"
        onClick={function () { setSheet({ kind: 'add' }); }}>{'+ ' + t('malsoModeBrokerClientsAdd')}</button>) : null}
    </div>
    <div style={lead}>{t('malsoModeBrokerClientsLead')}</div>
    {err ? <ErrorText>{describeSimpleError(t, err)}</ErrorText> : null}
    {!data ? (err ? null : <div style={S.emptyText}>{t('commonLoading')}</div>) : (<SimpleCard>
      {list.map(function (c, i) {
        var addr = c.isSelf ? selfAddr : (c.pickupAddress || t('malsoModeBrokerPickupNone'));
        return (<div key={c.id} data-client-id={c.id} style={i === list.length - 1 ? rowLast : row}>
          <span style={tx}>
            <span style={nameSt}>{c.name}
              {c.isSelf ? <span style={badgeSelf}>{t('malsoModeBrokerBadgeSelf')}</span>
                : c.joined ? <span style={badgeJoined}>{t('malsoModeBrokerBadgeJoined')}</span> : null}
            </span>
            {addr ? <span style={addrSt}>{addr}</span> : null}
          </span>
          {!c.isSelf && !c.joined && canManage ? (<button type="button" style={inviteBtn} data-action="invite"
            onClick={function () { setSheet({ kind: 'invite', client: c }); }}>{t('malsoModeBrokerInvite')}</button>) : null}
          {c.isSelf ? <span style={moreSlot} /> : (<button type="button" style={moreBtn} data-action="edit-pickup"
            aria-label={t('malsoModeBrokerEditPickup')} onClick={function () { setSheet({ kind: 'pickup', client: c }); }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
              <circle cx="5" cy="12" r="1.8" /><circle cx="12" cy="12" r="1.8" /><circle cx="19" cy="12" r="1.8" /></svg>
          </button>)}
        </div>);
      })}
    </SimpleCard>)}
    {data ? <div style={foot}>{t('malsoModeBrokerClientsFoot')}</div> : null}

    {sheet && sheet.kind === 'add' ? (<NewClientSheet accountName={data.accountName} agencyName={agencyName}
      onDone={function () { close(); load(); }} onClose={close} />) : null}
    {sheet && sheet.kind === 'invite' ? <MalsoInviteSheet client={sheet.client} showToast={showToast} onClose={close} /> : null}
    {sheet && sheet.kind === 'pickup' ? (<PickupEditSheet client={sheet.client} showToast={showToast} onClose={close}
      onSaved={function () { close(); showToast(t('malsoModeBrokerPickupSavedToast')); load(); }} />) : null}
  </div>);
}

export default MalsoClients;
